import { match } from 'ts-pattern';
export const migrateToV2 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().otherwise((other)=>other);
    });
};

//# sourceMappingURL=v2.js.map